export default __webpack_public_path__ + "media/images/icons/mini-slash-dc4338b6f79673d0b999da4ef174e94e.svg";